wbApp.controller('CoursesDetailCtrl', ['$scope', '$modal', 'courseSvc', 'tenantSettingSvc', 'localStorageService',
function ($scope, $modal, courseSvc, tenantSettingSvc, localStorageService) {

    if (localStorageService.isSupported) {
        if (!$scope.model.courseID) {
            $scope.model.lessonLengthInMinutes = localStorageService.get('lessonLengthInMinutes') || 45;
        }
    }

    $scope.modelOrig = angular.copy($scope.model);

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };

    $scope.onDetailSave = function (data) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        if (localStorageService.isSupported) {
            if ($scope.modelOrig.lessonLengthInMinutes != data.lessonLengthInMinutes) {
                localStorageService.set('lessonLengthInMinutes', data.lessonLengthInMinutes);
            }
        }

        if (!data.courseID) {
            courseSvc.insert(data, $scope.collection, success, error);
        } else {
            courseSvc.update(data, $scope.collection, success, error);
        }

        function success(model) {
            $scope.$hide();
            if (!!$scope.onCourseSave) {
                $scope.onCourseSave(model);
            }
        }

        function error(data) {
            $scope.detailError = data;
            $scope.isSaving = false;
        }
    }

    $scope.onSemesterChange = function (semesterID) {

    }

    $scope.teacherFromNowOnShouldShow = function () {
        return !!$scope.model.courseID && $scope.modelOrig.teacherIds !== $scope.model.teacherIds;
    }

    $scope.recurrence = {
        type: 1
    };

    $scope.enableZoomIntegration = tenantSettingSvc.settings.enableZoomIntegration;
    $scope.enableNewClientDesign = tenantSettingSvc.settings.enableNewClientDesign;

    $scope.detailTabs = [
    {
        title: 'TXT_MAIN',
        template: "courses/courses/detail-main-tab.html"
    }, {
        title: 'TXT_PRICE_TAB',
        template: "courses/courses/detail-price-tab.html"
    }, {
        title: 'TXT_COMPENSATION',
        template: "courses/courses/detail-compensation-tab.html"
    }, {
        title: 'TXT_COMPENSATION_GROUPS',
        template: "courses/courses/detail-compensation-groups-tab.html"
    }, {
        title: 'TXT_LBL_SETTING',
        template: "courses/courses/detail-settings-tab.html"
    }, {
        title: 'TXT_LBL_DESCRIPTION',
        template: "courses/courses/detail-description-tab.html"
    }, {
        title: 'TXT_LBL_PICTURES',
        template: "courses/courses/detail-pictures-tab.html"
    }, {
        title: 'TXT_LBL_FILES',
        template: "courses/courses/detail-protected-storage-tab.html"
    }];

    if (tenantSettingSvc.settings.enableAmortizationSchedules) {
        var index = _.findIndex($scope.detailTabs, { 'title': 'TXT_COMPENSATION' });

        $scope.detailTabs.splice(index, 0, {
            title: 'TXT_TAB_AMORTIZATION_SCHEDULE',
            template: "courses/courses/detail-amortization-schedule-tab.html"
        });        
    }


    $scope.detailTabs.activeTab = 0;

    $scope.onDeletePictureBtnClick = function (picture) {
        _.remove($scope.model.pictures || [], { imageUri: picture.imageUri });
    }

    $scope.onContentInfoAccessTimeChanged = function (contentInfoAccessTime) {
        switch (contentInfoAccessTime.accessTimeType) {
            case 0: // NoRestrictions
                contentInfoAccessTime.noOfDays = null;
                contentInfoAccessTime.accessAtUtc = null;
                break;
            case 1: // DaysFromBaseline
                contentInfoAccessTime.noOfDays = 0;
                contentInfoAccessTime.accessAtUtc = null;
                break;
            case 2: // AtSpecificDate
                contentInfoAccessTime.noOfDays = null;
                contentInfoAccessTime.accessAtUtc = new Date();
                break;
        }
    }

    $scope.onContentInfoDeleteBtnClick = function (contentInfo) {
        _.remove($scope.model.contentInfos || [], { objectUri: contentInfo.objectUri });
    }

    $scope.showProtectedStorageSelect = function () {
        protectedStorageSelectDlgPromise.$promise.then(function () {
            protectedStorageSelectDlgPromise.$scope.onFilesSelected = function (files) {

                if (!$scope.model.contentInfos) {
                    $scope.model.contentInfos = [];
                }

                angular.forEach(files, function (p) {
                    if (!_.find($scope.model.contentInfos, { objectUri: p.objectUri })) {
                        $scope.model.contentInfos.push({
                            objectUri: p.objectUri,
                            name: p.name,
                            description: null,
                            contentType: p.contentType,
                            accessTimeBaseline: 0, // AfterPayment
                            accessType: 1, // AccessToDownload
                            allowAccessFrom: {
                                accessTimeType: 1, // DaysFromBaseline
                                noOfDays: 0
                            },
                            allowAccessTo: {
                                accessTimeType: 0 // NoRestrictions
                            }
                        });
                    }
                });
            };
            protectedStorageSelectDlgPromise.show();
        });
    }

    var protectedStorageSelectDlgPromise = $modal({
        templateUrl: 'storage/protected-storage/protected-storage-select-dlg.html',
        show: false,
        scope: $scope.$new()
    });

    $scope.showPictureSelect = function () {
        picturesSelectDlgPromise.$promise.then(function () {
            picturesSelectDlgPromise.$scope.onPicturesSelected = function (pictures) {

                if (!$scope.model.pictures) {
                    $scope.model.pictures = [];
                }

                angular.forEach(pictures, function (p) {
                    if (!_.find($scope.model.pictures, { imageUri: p.imageUri }))
                    {
                        $scope.model.pictures.push(p);
                    }
                });
            };
            picturesSelectDlgPromise.show();
        });
    }

    var picturesSelectDlgPromise = $modal({
        templateUrl: 'storage/pictures/pictures-select-dlg.html',
        show: false,
        scope: $scope.$new()
    });

    $scope.addAmortizationSchedule = function() {
        $scope.model.amortizationSchedules.push({
            amount: null,
            percentageAmount: null,
            issueAt: null,
            issueDaysAfterRegistration: $scope.model.amortizationSchedules.length == 0 ? 0 : null
        });
    }

    $scope.removeAmortizationSchedule = function (schedule) {
        var index = _.indexOf($scope.model.amortizationSchedules, schedule);
        if (index > -1) {
            $scope.model.amortizationSchedules.splice(index, 1);
        }
    }

}]);
